import {
  Code2,
  Globe,
  Layers,
  Palette,
  Search,
  ShoppingCart,
} from "lucide-react";
import ScrollReveal from "./scroll-reveal";

const SERVICES = [
  {
    title: "Développement web",
    description:
      "Creation de site web: sites vitrines, landing pages et applications web rapides, clairs et orientes conversion.",
    bullets: [
      "Parcours utilisateur pensé pour la confiance",
      "Performance et accessibilité",
      "De la page simple au projet complexe",
    ],
    icon: Code2,
  },
  {
    title: "UI / UX Design",
    description:
      "Des interfaces agréables et des parcours fluides pour que vos visiteurs restent et reviennent.",
    bullets: ["Maquettes & prototypage", "Cohérence visuelle", "Design system"],
    icon: Palette,
  },
  {
    title: "Hébergement & domaine",
    description:
      "Mise en ligne fiable, chargement rapide et accompagnement pour choisir et gérer votre nom de domaine.",
    bullets: ["Hébergement adapté", "HTTPS & sauvegardes", "Conseil nom de domaine"],
    icon: Globe,
  },
  {
    title: "Optimisation SEO",
    description:
      "Structure, contenu et technique pour améliorer votre visibilité sur les moteurs de recherche.",
    bullets: ["SEO on-page", "Performance (Core Web Vitals)", "Balisage & données structurées"],
    icon: Search,
  },
  {
    title: "E-commerce",
    description:
      "Boutiques en ligne qui mettent vos produits en valeur et simplifient l’achat jusqu’au paiement.",
    bullets: ["Catalogue & fiches produit", "Tunnel de commande", "Paiement & logistique"],
    icon: ShoppingCart,
  },
  {
    title: "CMS headless",
    description:
      "Contenu éditable facilement, site rapide et front sur mesure — idéal pour évoluer sans friction.",
    bullets: ["API de contenu", "Équipe marketing autonome", "Multi-canal possible"],
    icon: Layers,
  },
];

export function ServicesSection() {
  return (
    <section id="services" className="relative w-full overflow-hidden bg-surface py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0 bg-hero-glow opacity-40" aria-hidden />
      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Expertise</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white md:text-5xl">
            Services
          </h2>
          <p className="mt-4 text-balance text-lg text-zinc-500">
             Une offre complete pour votre presence en ligne — strategie, design, developpement et
            croissance.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service, index) => {
            const Icon = service.icon;
            return (
              <ScrollReveal
                key={service.title}
                delay={index * 90}
                distance={24}
                duration={700}
                threshold={0.12}
              >
                <article className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-surface-card p-7 shadow-card transition duration-300 hover:border-brand/25 hover:shadow-glow">
                  <div className="flex items-start justify-between gap-3">
                    <span className="font-mono text-xs text-zinc-600">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand/10 text-brand transition group-hover:bg-brand/20">
                      <Icon className="h-5 w-5" strokeWidth={1.75} />
                    </span>
                  </div>
                  <h3 className="mt-5 font-display text-xl font-semibold text-white">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-zinc-500">
                    {service.description}
                  </p>
                  <ul className="mt-5 space-y-2.5 text-sm text-zinc-400">
                    {service.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2.5">
                        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-brand/80" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </article>
              </ScrollReveal>
            );
          })}
        </div>

        <div className="mx-auto mt-14 max-w-4xl rounded-2xl border border-white/[0.08] bg-gradient-to-br from-surface-card to-surface-raised p-8 md:flex md:items-center md:justify-between md:p-10">
          <div className="text-center md:text-left">
            <p className="font-display text-xl font-semibold text-white">Un projet en tête ?</p>
            <p className="mt-2 text-sm text-zinc-500">
              Décrivez vos objectifs — je reviens vers vous avec une proposition claire.
            </p>
          </div>
          <a
            href="#contact"
            className="mt-6 inline-flex w-full shrink-0 items-center justify-center rounded-2xl bg-brand px-8 py-3.5 text-sm font-semibold text-surface transition hover:bg-brand-bright md:mt-0 md:w-auto"
          >
            Parlons-en
          </a>
        </div>
      </div>
    </section>
  );
}
